module.exports = __webpack_public_path__ + "static/media/budgetsmart-promo.2e9342c3.webp";